// /src/services/auth/utils.js

// Convert a base64URL string to an ArrayBuffer
export function base64URLStringToBuffer(base64URLString) {
    // Convert base64URL to base64
    const base64 = base64URLString.replace(/-/g, '+').replace(/_/g, '/');
    const paddedBase64 = base64.padEnd(base64.length + (4 - (base64.length % 4)) % 4, '=');
    
    // Convert base64 to binary string
    const binaryString = atob(paddedBase64);
    
    // Convert binary string to ArrayBuffer
    const buffer = new ArrayBuffer(binaryString.length);
    const uint8Array = new Uint8Array(buffer);
    
    for (let i = 0; i < binaryString.length; i++) {
      uint8Array[i] = binaryString.charCodeAt(i);
    }
    
    return buffer;
  }
  
  // Convert an ArrayBuffer to a base64URL string
  export function bufferToBase64URLString(buffer) {
    // Convert ArrayBuffer to binary string
    const uint8Array = new Uint8Array(buffer);
    let binaryString = '';
    uint8Array.forEach(byte => {
      binaryString += String.fromCharCode(byte);
    });
    
    // Convert binary string to base64
    const base64 = btoa(binaryString);
    
    // Convert base64 to base64URL
    return base64.replace(/\+/g, '-')
                 .replace(/\//g, '_')
                 .replace(/=/g, '');
  }
  
  // Validate email format
  export function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
  
  // Parse JWT token without validation
  export function parseJwt(token) {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      return JSON.parse(window.atob(base64));
    } catch (error) {
      console.error('Error parsing JWT:', error);
      return null;
    }
  }